// extracted by mini-css-extract-plugin
export var flowchartContainer = "_i-0";